export const EVENTS = {
  DISPATCH_DEPENDENT_INCLUDE_BUTTON: 'dispatchDependentIncludeButton',
};
